import { makeAutoObservable } from "mobx";
import SearchState from "../../SearchState";

export default class ShareState {
  /** @type {SearchState} */
  searchState;

  showingVideoEntry = 0;

  /** @type {string} */
  shortLink = "";

  hasBeenCopied = false;

  /**
   * @param {SearchState} searchState
   */
  constructor(searchState) {
    makeAutoObservable(this, {}, { enforceActions: "observed" });
    this.searchState = searchState;
  }

  /**
   * Copies text to clipboard using modern API or fallback
   * @param {string} text - Text to copy
   * @returns {Promise<void>}
   */
  copyTextToClipboard = async (text) => {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
    return document.execCommand("copy", true, text);
  };
}
